import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GenerateSignalMutationVariables = Types.Exact<{
  input: Types.GenerateSignalInput;
}>;

export type GenerateSignalMutation = {
  __typename?: 'Mutation';
  generateSignal: {
    __typename?: 'GeneratedSignalResult';
    name: string;
    description: string;
    signalType: Types.SignalType;
    confidence: number;
    reasoning: string;
    fingerprints: Array<{
      __typename?: 'GeneratedFingerprint';
      field: string;
      operator: Types.ConditionOperator;
      value: any;
    }>;
  };
};

export const GenerateSignalDocument = gql`
  mutation GenerateSignal($input: GenerateSignalInput!) {
    generateSignal(input: $input) {
      name
      description
      signalType
      fingerprints {
        field
        operator
        value
      }
      confidence
      reasoning
    }
  }
`;
export type GenerateSignalMutationFn = Apollo.MutationFunction<
  GenerateSignalMutation,
  GenerateSignalMutationVariables
>;

/**
 * __useGenerateSignalMutation__
 *
 * To run a mutation, you first call `useGenerateSignalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSignalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSignalMutation, { data, loading, error }] = useGenerateSignalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateSignalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateSignalMutation,
    GenerateSignalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateSignalMutation,
    GenerateSignalMutationVariables
  >(GenerateSignalDocument, options);
}
export type GenerateSignalMutationHookResult = ReturnType<
  typeof useGenerateSignalMutation
>;
export type GenerateSignalMutationResult =
  Apollo.MutationResult<GenerateSignalMutation>;
export type GenerateSignalMutationOptions = Apollo.BaseMutationOptions<
  GenerateSignalMutation,
  GenerateSignalMutationVariables
>;
